export const video = `
    video {
        object-fit: cover;
    }
`